// extracted by mini-css-extract-plugin
export default {"placeHolder":"MunicipalitySummaryPage_placeHolder__bzWrH"};